import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseButton from 'src/common/components/base-button';
import { IActionButton } from 'src/common/interfaces/dtos/ICashOfficeActionButton';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import SizedGridItem from 'src/sized-grid-item/sized-grid-item';
import VerticalCenter from 'src/vertical-center/vertical-center';
import {
  horizontalActionWindowButtonGroupStyles,
  horizontalActionWindowTitleStyles,
  styles,
} from './horizontal-action-window-button-area-styles';
import TrainingModeWatermark from 'src/common/training-mode/training-mode-watermark';

const HorizontalActionWindowButtonsGroup = ({
  actionList,
}: HorizontalActionWindowButtonAreaProps): JSX.Element => {
  const classes = horizontalActionWindowButtonGroupStyles();
  const { t } = useTranslation();
  return (
    <Grid
      container
      direction='row'
      className={classes.actionWindowButtonContent}
      data-testid='horizontal-action-window-button-container'
    >
      {actionList.map(
        (action): JSX.Element => {
          return (
            <BaseButton
              buttonType='white'
              className={classes.actionWindowButton}
              onClick={action.handleClick}
              disabled={action.isDisabled}
              data-testid={action.id}
              id={action.id}
              key={action.id}
            >
              {t(action.text)}
            </BaseButton>
          );
        },
      )}
    </Grid>
  );
};

const generateHorizontalActionWindowTitle = ({
  testId,
  title,
}: HorizontalActionWindowTitleProps): JSX.Element => {
  const classes = horizontalActionWindowTitleStyles();
  return (
    <Grid container data-testid={testId} className={classes.titleContainer}>
      <Grid item>
        <VerticalCenter justifyContent='flex-start'>
          <Typography
            className={classes.titleTypography}
            data-testid='horizontal-action-window-button-area-title-text'
          >
            {title}
          </Typography>
        </VerticalCenter>
      </Grid>
    </Grid>
  );
};

export const HorizontalActionWindowButtons: React.FC<HorizontalActionWindowButtonsProps> = ({
  trainingModeActive,
  titleProps,
  buttonProps,
}: HorizontalActionWindowButtonsProps): JSX.Element => {
  const classes = styles();
  const trainingModeClasses = trainingModeStyles();
  return (
    <Grid
      container
      direction='column'
      className={` ${
        trainingModeActive ? trainingModeClasses.trainingModeBackground : classes.background
      } fullHeight`}
      data-testid='horizontal-action-window-tab-area'
    >
      {trainingModeActive && <TrainingModeWatermark />}
      <SizedGridItem size={'1.3vh'}></SizedGridItem>
      <SizedGridItem size={'11.8vh'}>
        {generateHorizontalActionWindowTitle(titleProps)}
      </SizedGridItem>
      <HorizontalActionWindowButtonsGroup {...buttonProps} />
    </Grid>
  );
};

interface HorizontalActionWindowTitleProps {
  title: string;
  testId: string;
}

interface HorizontalActionWindowButtonAreaProps {
  actionList: IActionButton[];
}

interface HorizontalActionWindowButtonsProps {
  titleProps: HorizontalActionWindowTitleProps;
  buttonProps: HorizontalActionWindowButtonAreaProps;
  trainingModeActive?: boolean;
}
